import { render, staticRenderFns } from "./TheContainerFluid.vue?vue&type=template&id=622b96c6&"
import script from "./TheContainerFluid.vue?vue&type=script&lang=js&"
export * from "./TheContainerFluid.vue?vue&type=script&lang=js&"
import style0 from "./TheContainerFluid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports